export class FetchDiscriminationTypes {
  public static readonly type = '[DiscriminationTypes] Fetch discriminationTypes';
}
